<template>
  <!--@我的-->
  <div class="ay-content-list"  v-infinite-scroll="loadMore"  infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-throttle-delay="1000">
    <div class="ay-link ay-cor" v-if="conten" v-for="item in conten">
      <div class="ay-close" :attr-id="item.id"></div>
      <p class="ay-title-time">{{item.create_time|datetime}}</p>
      <div class="clearfix">
         <router-link class="ay-info" tag="div" :to="{name:'Detail',params: {id: item.activity_mini.id}}" style="float:left;width: 69%">
          <div style="width: 44px;height: 44px;display: inline-block;float: left;border-radius: 50%;">
          <img  v-if="item.activity_mini && item.activity_mini.hostunit" style="width: 44px;height: 44px;margin-top:12px;border-radius: 50%;overflow: hidden" class="ay-info-pic" :src="item.activity_mini.hostunit.host_avatar" alt=""/>
          </div>
          <p style="float: none;line-height: 44px"  v-if="item.activity_mini && item.activity_mini.hostunit">
            {{item.activity_mini.hostunit.channel_name}}
            <span>@</span>您
          </p>
          </router-link>
        <div class="video-img" style="float: right;width: 30%;margin-top: 10px;position: relative">
          <a href="javascript:void(0);"  class="ay-info" @click="water(item)">
            <img style="height: 100%" v-if="item.file && item.file_type == 'video'" :src="item.file.thumb_url" alt=""/>
            <img style="height: 100%" v-if="item.file && item.file_type == 'image'" :src="item.file.image_url" alt=""/>
            <img style="height: 100%" v-if="item.msg_type == 1" :src="item.image_url" alt=""/>
          </a>
          <i style="position:absolute;right: 2px;bottom: 2px;font-size: 12px;font-style: normal; background: rgba(100, 100, 100, .5);color: #fff;padding: 0 2px;border-radius: 4px" class="ay-pic-t" v-if="item.file && item.file.time_span">{{item.file.time_span | formatSeconds}}</i>
        </div>
      </div>
      <div class="ay-info-text" style="margin: 5px">
        {{item.content.msg}}
      </div>
    </div>
    <div class="foll_div" v-if="conten.length==0" >
      <div class="content index-content">
        <div class="id-content-inner">
          <div class="loader">
            <div class="loader-inner ball-pulse" style="display: block">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- load -->
    <div class="content index-content" v-show="!busy" style="padding-top: 5px">
      <div class="id-content-inner">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <!--删除-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModals" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 id="file-h3" class="Prompt-p">你确定要删除此条信息？  </h3>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="DelFile">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Scan :show.sync="scan.show" :url="scan.url" />
  </div>
</template>

<script>
  import Scan from '../template/imgSan.vue'
    export default {
      components: {Scan},
      props: [
        'userId',
        'initUtil'
      ],
      data (){
        return {
          conten: [],
          ind: '',
          id: '',
          busy: false,
          page: 0,
          data: '',
          scan:{
            show: false,
            url: ''
          },
        }
    },
    methods: {
        //操作按钮事件
      DelFile(){
        var that = this;
       // console.log(that.id)
        $.getJSON(API.DelActivityMsgById +'?jsoncallback=?&msg_id=' + that.id,function(res){
        //  console.log(res);
          if(res.code == 0){
            $('.ay-close').eq(that.ind).parent().remove();
            $('#editModals').modal('hide')
          }else{
            alert('此条信息已被删除')
          }

        })
      },
      water(item){
       //console.log(item)
        var that = this;
        this.data = new Date();
        var fileItem = '';
        if(item.file){
          if(item.file_type == 'video'){
            that.$router.push({name:'VideoName',params: {id:item.activity_mini.id,uuid: item.file.uuid,type:'video'}})
          }else{
            that.$router.push({name:'VideoName',params: {id:item.activity_mini.id,uuid:item.file.image_id,type:'image'}})
          }
        }else if(item.msg_type == 1){
          this.scan = {
            show: true,
            url: item.image_url
          }
        }
      },
      //加载更多
      loadMore(){
        this.busy = true;
        // 多次加载数据
        setTimeout(() => {
          this.page ++;
        this.ajaxMore(true);
      }, 500)

    },
    ajaxMore(flag){
      var that = this;
      this.$http.get(API.GetActivityMsgList, {params: {page: that.page,pagesize: 10}})
        .then(function (res) {
        // console.log(res)
          if(res.code == 0){
            if(flag){
              for(var i=0;i<res.data.length;i++){
                that.conten.push(res.data[i])
              }
              if (res.data.length === 0 || that.conten.length === res.total) {
                that.busy = true
              } else {
                that.busy = false
              }
            }
            that.$nextTick(function () {
              var w = $('.video-img').width();
              $('.video-img').css("height",w /16 *9);
            })
            if(res.total == 0){
              $('.foll_div').html('还没有活动@您！')
            }
          }
        });
      }
    },
    created: function(){
      var that = this;
      this.initUtil.stopBodyScroll(false);
      //@我的
      $('.icon-back').removeClass('pointerEve');
    },
    mounted: function () {
        //操作DOM
      $('.icon-back').show();
      var that = this;
      $('.ay-content-list').on('click','.ay-close',function(){
        that.ind = $(this).parent().index();
        that.id= $(this).attr('attr-id');
        $('#editModals').modal('show')
      })

        $('.nav').children('.id-nav-recom').eq(3).addClass('nav-on').siblings().removeClass('nav-on')

        $('.nav').children('.id-nav-recom').eq(3).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active')

      //微信分享
      let metas = $('head').children('meta');
    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/myActivity/notice.vue